<template>
	<div>
		<div class="nav-back"></div>
		<div
			class="navbar fixed"
			:class="{ mobile: isMobile, collapsed: isCollapsed }"
			@click.stop="closeDropdown"
		>
			<div v-if="isMobile" class="navbar-brand">

				<a class="navbar-burger back" @click="navigateBack">
					<i class="fas fa-arrow-left" />
				</a>
				<customer-picker-button />
      <div class="navbar-item lang-switcher">
          <LanguageSwitcher />
        </div>
				<a class="navbar-burger" @click="openMenu">
					<span></span><span></span><span></span>
				</a>
			</div>

			<div v-if="!isMobile" class="navbar-menu">
				<div class="navbar-start">
					<customer-picker-button />
				</div>

				<div class="navbar-end">
					<div class="navbar-item filler"></div>
					<div class="edge-container">
						<div class="edge-right" />
					</div>

			  <div class="navbar-item lang-switcher">
          <LanguageSwitcher />
        </div>


					<div class="navbar-item">
						<p>{{ $t('navbar.welcome') }}{{ getUser ? ', ' + getUser.firstName : '' }}</p>
						<div class="box circle" @click.stop="toggleDropdown">
							<i class="fas fa-user"></i>
						</div>
					</div>
				</div>
			</div>

			<transition name="slide-down">
				<div class="menu absolute" v-if="showDropdown">
					<ul class="menu-list">
						<li @click="logout">
							<a><i class="fas fa-sign-out-alt" />{{ $t('navbar.logout') }}</a>
						</li>
					</ul>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
import CustomerPickerButton from '@/components/customer/customer-picker-button';
import LanguageSwitcher from '@/components/LanguageSwitcher.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    CustomerPickerButton,
    LanguageSwitcher
  },
  props: {
    closeMenu: Boolean
  },
  data() {
    return {
      showDropdown: false
    };
  },
  computed: {
    ...mapGetters('appStore', ['isMobile', 'isCollapsed']),
    ...mapGetters('user', ['getUser'])
  },
  watch: {
    closeMenu(val) {
      if (val) this.showDropdown = false;
    }
  },
  methods: {
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
      this.$emit('showDropdown', this.showDropdown);
    },
    closeDropdown() {
      this.showDropdown = false;
      this.$emit('showDropdown', this.showDropdown);
    },
    logout() {
      this.$emit('logout');
    },
    openMenu() {
      this.$emit('openMenu');
    },
    navigateBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/variables.scss";
@import "@/assets/colors.scss";


.lang-switcher {
	margin-right: 1rem;
	.dropdown {
		.button {
			font-size: 0.85rem;
		}
	}
}

.nav-back {
	height: $navbar-height;
	background-color: $navbar-background;
	width: 100%;
	top: 0;
	position: fixed;
	z-index: 3;
}

.navbar.fixed {
	background-color: transparent;
	height: 0;
	width: calc(100% - #{$menu-width});
	top: 0;
	left: $menu-width;
	position: fixed;
	z-index: 9;

	&.collapsed {
		left: $menu-collapsed-width;
		width: calc(100% - #{$menu-collapsed-width});
	}
}

.navbar.fixed.mobile {
	width: 100vw;
	left: 0;
}

.navbar-end {
	margin-left: 20px;
	background-color: $navbar-end-background;
	position: relative;
	z-index: 12;

	.navbar-item {
		background-color: $navbar-end-background;
		font-size: 14px;
	}

	.navbar-item.filler {
		background-color: $navbar-background;
		width: 40px;
	}
}

.navbar-item p {
	color: $navbar-color;
}

.edge-container {
	position: relative;
}

.edge-right {
	position: absolute;
	transform: skew(-30deg);
	right: -20px;
	background-color: $navbar-end-background;
	width: 40px;
	height: 100%;
}

.navbar-start {
	width: calc(100% - 240px);
	background-color: transparent;

	.navbar-item:first-child {
		width: 200px;
	}

	.navbar-item:nth-child(2) {
		margin-left: auto;
	}

	.navbar-item {
		padding-left: 18px;
		background-color: $navbar-background;
	}
}

.navbar-item .box.circle {
	border-radius: 50px;
	background-color: $info;
	color: $white;
	margin-left: 10px;
	height: 20px;
	padding: 17px;
	position: relative;
	overflow: hidden;
	cursor: pointer;

	i {
		position: absolute;
		right: 6px;
		bottom: -1px;
		font-size: 26px;
		color: $white;
	}
}

.menu.absolute {
	width: 150px;
	background-color: $navbar-background;
	position: absolute;
	right: 0;
	top: $navbar-height;
	border: 1px solid $navbar-border;
	z-index: 10;
	border-top: none;
}

li a {
	color: $navbar-color;
	font-size: 13px;

	&:hover {
		background-color: $info;
		color: $white;

		i {
			color: $white;
		}
	}

	i {
		margin-right: 10px;
	}
  }

.flag-icon {
  width: 24px;
  height: 16px;
  margin-right: 8px;
  vertical-align: middle;
}
</style>
